<template>
    <!-- COMPANY_CLASS_MODAL -->
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template #body>
                <div class="d-flex justify-content-center">
                    <div class="border">
                        <!-- <h5 class="code-subtitle text-center">비밀번호 변경</h5> -->
                        <div class="d-flex flex-wrap flex-sm-nowrap justify-content-center">
                        <div class="p-5">
                            <div class="form-text mb-2" id=""><span class="text-danger">이전에 사용한 적 없는 비밀번호</span>가 <br>안전합니다.</div>
                            <div class="mb-3" v-if="!props.isAdmin">
                                <ElLabel name="현재 비밀번호">
                                    <template v-slot:end="{id}">
                                        <ElInput :id="id" v-model="user.old_passwd" type="password" @inputKeyupEnter="pwdChange"/>
                                    </template>
                                </ElLabel>
                            </div>
                            <div class="mb-3">
                                <ElLabel name="새 비밀번호">
                                    <template v-slot:end="{id}">
                                        <ElInput :id="id" v-model="user.new_passwd" type="password" @inputKeyupEnter="pwdChange" @update:modelValue="warnMsgMng()"/>
                                        <div class="form-text mb-3" v-show="warnMsg.form">
                                            <span class="text-danger">영대/소문자, 숫자, 특수문자 포함<br>8자리 이상이여야합니다.</span>
                                        </div>
                                    </template>
                                </ElLabel>
                            </div>
                            <div class="mb-3">
                                <ElLabel name="새 비밀번호 확인">
                                    <template v-slot:end="{id}">
                                        <ElInput :id="id" v-model="user.new_passwd_confim" type="password" @inputKeyupEnter="pwdChange" @update:modelValue="warnMsgMng()"/>
                                        <div class="form-text mb-3" v-show="warnMsg.equalPwd">
                                            <span class="text-danger">새 비밀번호와 비밀번호 확인이<br>일치하지 않습니다.</span>
                                        </div>
                                    </template>
                                </ElLabel>
                            </div>
                        </div>

                        <!--todo : 추후 리캡챠 기능 추가되면 적용 -->
                        <!-- <div class="p-5">
                            <div class="form-text mb-3" id="">아래 이미지를 보이는 대로 입력해 주세요.</div>
                            <div class="py-3"></div>
                            <div class="mb-3">
                            <input type="password" class="form-control" id="" placeholder="자동입력 방지문자">
                            </div>
                        </div> -->
                        </div>
                        <!-- <div class="p-3 text-center border-top"> -->
                        <!-- <button class="btn btn-primary">확인</button>
                        <button class="btn btn-primary">취소</button> -->
                        <!-- </div> -->
                    </div>
                </div>




        </template>
    </BaseModal>


</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '@/components/common/modal/BaseModal.vue';
import { userPasswordChange,passwordChange } from '@/api/auth';

import { useUserStore } from '@/store/user';
const userStore = useUserStore()
import { useLoading } from '@/composable/Loading.js'
import common from '@/js/common';

const { setIsLoading } = useLoading()
const baseModalRef = ref()
const emits = defineEmits(['return'])

const props = defineProps({
    user: {
        type: String,
        default: ''
    },
    isAdmin:{
        type: Boolean,
        default: false
    }
})

const childProps = ref({
    modalId : 'pwdChangeModal',
    modalNm : '비밀번호 변경',
    size:'sm',
    btnList : [
        {name : '비밀번호 변경' , classNm : 'search',function : pwdChange}
    ]
})

const user = ref({
    old_passwd : '',
    new_passwd : '',
    user_id : props.user || userStore.user.userId,
    new_passwd_confim : ''
})

const warnMsg = ref({
    form : false,
    equalPwd : false
})

function openModal(){
    baseModalRef.value.openModal()
}

function closeModal(){
    baseModalRef.value.closeModal()
}


async function pwdChange(){
    if(validation()){
        user.value.user_id =  props.user || userStore.user.userId

        if(props.isAdmin){
            try{
                    setIsLoading(true)
                    const res = await passwordChange(user.value)
                    if(res.code === '0000'){
                        alert('비밀번호 변경에 성공했습니다.')
                        closeModal()
                    }else{
                        alert('사용자가 존재하지 않거나 비밀번호가 일치하지 않습니다.')
                    }
                }catch(e){
                    console.log(e)
                }finally{
                    setIsLoading(false)
                }
        }else{
                try{
                    setIsLoading(true)
                    const res = await userPasswordChange(user.value)
                    if(res.code === '0000'){
                        alert('비밀번호 변경에 성공했습니다.')
                        closeModal()
                    }else{
                        alert('사용자가 존재하지 않거나 비밀번호가 일치하지 않습니다.')
                    }
                }catch(e){
                    console.log(e)
                }finally{
                    setIsLoading(false)
                }
        }
    }


}

function validation(){
    if(!props.isAdmin && !user.value.old_passwd.trim()){
        alert('기존 비밀번호를 확인해주세요')
        return
    }else if(!user.value.new_passwd.trim()){
        alert('변경할 비밀번호를 입력해주세요')
        return
    }else if(!user.value.new_passwd_confim.trim()){
        alert('비밀번호 확인을 입력해주세요')
        return
    }else if(!common.checkPwdForm(user.value.new_passwd)){
        alert('비밀번호 규칙에 맞지 않습니다.(영대/소문자, 숫자, 특수문자 포함 8자리 이상이여야합니다.)')
        return
    }else if(user.value.new_passwd !== user.value.new_passwd_confim){
        alert('새 비밀번호와 비밀번호 확인이 일치하지 않습니다.')
        return
    }

    return true
}

function warnMsgMng(){
    warnMsg.value.form = !common.checkPwdForm(user.value.new_passwd)
    warnMsg.value.equalPwd = !(user.value.new_passwd === user.value.new_passwd_confim)
}

defineExpose({
    openModal,
    
})



</script>